import { render, staticRenderFns } from "./indexMY.vue?vue&type=template&id=1446546a&scoped=true"
import script from "./indexMY.vue?vue&type=script&lang=js"
export * from "./indexMY.vue?vue&type=script&lang=js"
import style0 from "./indexMY.vue?vue&type=style&index=0&id=1446546a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1446546a",
  null
  
)

export default component.exports